import React, { useState, useRef, useEffect } from 'react';
import { C } from '../constants/theme';
import { NAV_ITEMS } from './Sidebar';
import { Menu, LogOut, User } from 'lucide-react';

export function Topbar({ page, onToggleSidebar, user, onLogout }) {
  const current = NAV_ITEMS.find((n) => n.key === page);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const initials = user?.firstName
    ? `${user.firstName} ${user.lastName || ''}`.trim()
      .split(' ')
      .map((w) => w[0])
      .slice(0, 2)
      .join('')
      .toUpperCase()
    : 'U';

  const fullName = user
    ? `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.userName
    : 'User';

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const CurrentIcon = current?.icon;

  return (
    <div style={{
      background: C.white,
      borderBottom: `1px solid ${C.border}`,
      padding: '0 24px',
      height: 56,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      zIndex: 50,
    }}>

      {/* Left */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <button
          onClick={onToggleSidebar}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: C.textMuted, padding: 4, display: 'flex',
            alignItems: 'center', borderRadius: 6,
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#F5F3FC'}
          onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
        >
          <Menu size={20} strokeWidth={1.8} />
        </button>

        {current && CurrentIcon && (
          <span style={{
            background: C.primaryLight,
            color: C.primary,
            borderRadius: 20,
            padding: '5px 14px',
            fontSize: 13,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 7,
          }}>
            <CurrentIcon size={14} strokeWidth={2} color={C.primary} />
            {current.label}
          </span>
        )}
      </div>

      {/* Right */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <span style={{ fontSize: 13, color: C.textMuted }}>
          {new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
        </span>

        {/* Avatar dropdown */}
        <div ref={ref} style={{ position: 'relative' }}>
          <button
            onClick={() => setOpen((o) => !o)}
            style={{
              width: 36, height: 36, borderRadius: '50%',
              background: C.primary,
              border: 'none', cursor: 'pointer',
              color: '#fff', fontWeight: 700, fontSize: 13,
              fontFamily: 'inherit',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: open ? `0 0 0 3px ${C.primaryLight}` : 'none',
              transition: 'box-shadow .15s',
            }}
          >
            {initials}
          </button>

          {open && (
            <div style={{
              position: 'absolute', right: 0, top: 44, width: 230,
              background: C.white, borderRadius: 12,
              border: `1px solid ${C.border}`,
              boxShadow: '0 8px 32px rgba(108,63,197,.12)',
              zIndex: 200, overflow: 'hidden',
            }}>
              {/* User info */}
              <div style={{ padding: '14px 16px', borderBottom: `1px solid ${C.border}` }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                  <div style={{
                    width: 38, height: 38, borderRadius: '50%',
                    background: C.primary,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontWeight: 700, fontSize: 13, flexShrink: 0,
                  }}>
                    {initials}
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <div style={{
                      fontSize: 13, fontWeight: 700, color: C.text,
                      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                    }}>
                      {fullName}
                    </div>
                    <div style={{
                      fontSize: 11, color: C.textMuted, marginTop: 2,
                      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                    }}>
                      {user?.userEmail || user?.email || ''}
                    </div>
                  </div>
                </div>
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 5,
                  background: C.primaryLight, color: C.primary,
                  borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 600,
                }}>
                  <User size={11} strokeWidth={2.5} />
                  {user?.role || 'Admin'}
                </div>
              </div>

              {/* Logout */}
              <button
                onClick={() => { setOpen(false); onLogout(); }}
                style={{
                  width: '100%', padding: '12px 16px',
                  background: 'none', border: 'none',
                  cursor: 'pointer', textAlign: 'left',
                  fontSize: 13, color: C.danger,
                  fontWeight: 600, fontFamily: 'inherit',
                  display: 'flex', alignItems: 'center', gap: 8,
                  transition: 'background .15s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#FFF0F0'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
              >
                <LogOut size={15} strokeWidth={2} color={C.danger} />
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}